module.exports = __webpack_public_path__ + "img/mobile_banking_bay.1911ebe5.png";